import React, { Component } from 'react'
import { Card, List, Image } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';

import LinkButton from '../../components/link-button'

import { connect } from 'react-redux'
import { req_single_category } from '../../api'

import { API_BASE } from '../../utils/contrains'
import './product.less'

const Item = List.Item

class ProductDetails extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    state = {
        CategoryParentName: '-',
        CategoryName: ''
    }

    componentDidMount() {
        const { CatalogParentNid, CatalogNid } = this.props.location.state.product
        if (CatalogParentNid === 0) {
            // 一層分類
            this.api_single_level1_category(CatalogNid)
        } else {
            // 二層分類
            this.api_single_level2_category(CatalogNid, CatalogParentNid)
        }
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_level1_category = async (id) => {
        const token = this.props.user.token
        const result = await req_single_category(id, token)
        //console.log(result)
        const { categoryName } = result
        this.setState({ CategoryName: categoryName })
    }

    api_single_level2_category = async (id, pid) => {
        const token = this.props.user.token
        const results = await Promise.all([req_single_category(id, token), req_single_category(pid, token)])
        this.setState({ CategoryName: results[0].categoryName, CategoryParentName: results[1].categoryName })
        //  console.log(this.state)
    }

    /////////////////////////////////////////////////////////// 

    render() {
        const { CategoryParentName, CategoryName } = this.state
        const { ProductName, ProductDetails, ProductPrice, RecordDescription, Appendices } = this.props.location.state.product

        const title = (
            <span>
                <LinkButton><ArrowLeftOutlined style={{ color: 'green', marginRight: 15, fontSize: 20 }} onClick={() => this.props.history.goBack()} /></LinkButton>
                物件明細
            </span>
        )

        return (
            <Card title={title} className='product-details'>
                <List>
                    <Item>
                        <span>
                            <span className="left">物件名稱：</span>
                            <span>{ProductName}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">物件描述：</span>
                            <span>{ProductDetails}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">物件價值：</span>
                            <span>${ProductPrice}元</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">所屬分類：</span>
                            <span>{CategoryParentName} / {CategoryName}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">物件圖片：</span>
                            <span>
                                {
                                    (Appendices) ?
                                        Appendices.map(img =>
                                        (
                                            <Image
                                                key={img.FileNid}
                                                width={150}
                                                src={API_BASE + img.FileUrl}
                                                alt="" />
                                        )
                                        ) : null
                                }
                            </span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">物件詳述：</span>
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: RecordDescription }} />
                            </span>
                        </span>
                    </Item>
                </List>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ProductDetails)